import { _ as _extends } from './extends-3e8335ef.esm.js';
import React__default from 'react';
import { a as AppErrorMessage } from './AppFormField-8e8773f8.esm.js';
import { useFormikContext } from 'formik';
import { A as AppCodeInput } from './index-b024b44b.esm.js';

function AppFormCodeInput(_ref) {
  let {
    value,
    setValue,
    name,
    left,
    ...otherProps
  } = _ref;
  const {
    setFieldValue,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppCodeInput, _extends({
    setValue: b => setFieldValue(name, b),
    value: values && values[name]
  }, otherProps)), errors[name] && values[name] != "" && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    top: -18,
    left: 113,
    message: errors[name]
  }));
}
AppFormCodeInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormCodeInput"
};

export { AppFormCodeInput as A };
